// extracted by mini-css-extract-plugin
export default {"viewer":"warehouse-viewer_viewer__PBitL","map":"warehouse-viewer_map__H3z1l","hidden":"warehouse-viewer_hidden__EVZIH"};